import { JourneyConstants } from '../utils/constants/JourneyConstants';
import { HttpMethods } from '../utils/constants/HttpMethodsConstants';
import APIHelper from '../utils/helpers/APIHelper';
import APIParamsBuilderHelper from '../utils/helpers/APIParamsBuilderHelper';
import { getUser } from './AuthService';

/**
 * @class JourneyService
 * @description Storehouse for all Journey related APIs.
 */
class JourneyService {
  /**
   * @function getSession
   * @description get current insured session data.
   */
  public static async getSession(): Promise<string> {
    const user = getUser();
    const params =
      `?email=${user.email}&firstName=${user.given_name}` +
      `&lastName=${user.family_name}&state=${user.state}&specialty=${user.specialty}`;

    const requestConfig = new APIParamsBuilderHelper.ParamsBuilder(
      JourneyConstants.GET_INSURED_SESSION + params,
      HttpMethods.GET,
    ).build().getConfig;
    return APIHelper.sendRequest(requestConfig)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  }

  /**
   * @function getIndData
   * @description get current insured indication data.
   */
  public static async getIndData(): Promise<string> {
    const user = getUser();
    const params =
      `?email=${user.email}&firstName=${user.given_name}` +
      `&lastName=${user.family_name}&state=${user.state}&specialty=${user.specialty}`;

    const requestConfig = new APIParamsBuilderHelper.ParamsBuilder(
      `${JourneyConstants.GET_INSURED_INDICATION}${params}`,
      HttpMethods.GET,
    ).build().getConfig;

    return APIHelper.sendRequest(requestConfig)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  }
}

export default JourneyService;
